/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Measure_Sparkline_LabelInputs */

const en_measure_sparkline_label = /** @type {(inputs: Measure_Sparkline_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trend sparkline`)
};

const zh_hans1_measure_sparkline_label = /** @type {(inputs: Measure_Sparkline_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`趋势迷你图`)
};

const pt_br2_measure_sparkline_label = /** @type {(inputs: Measure_Sparkline_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`minigráfico de tendência`)
};

const es_measure_sparkline_label = /** @type {(inputs: Measure_Sparkline_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`minigráfico de tendencia`)
};

const fr_measure_sparkline_label = /** @type {(inputs: Measure_Sparkline_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`courbe de tendance`)
};

const de_measure_sparkline_label = /** @type {(inputs: Measure_Sparkline_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trend-Sparkline`)
};

const ru_measure_sparkline_label = /** @type {(inputs: Measure_Sparkline_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`график динамики`)
};

const it_measure_sparkline_label = /** @type {(inputs: Measure_Sparkline_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`grafico sparkline dell'andamento`)
};

/**
* | output |
* | --- |
* | "trend sparkline" |
*
* @param {Measure_Sparkline_LabelInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_sparkline_label = /** @type {((inputs?: Measure_Sparkline_LabelInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_Sparkline_LabelInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_sparkline_label(inputs)
	if (locale === "pt-BR") return pt_br2_measure_sparkline_label(inputs)
	if (locale === "es") return es_measure_sparkline_label(inputs)
	if (locale === "fr") return fr_measure_sparkline_label(inputs)
	if (locale === "de") return de_measure_sparkline_label(inputs)
	if (locale === "ru") return ru_measure_sparkline_label(inputs)
	if (locale === "it") return it_measure_sparkline_label(inputs)
	return en_measure_sparkline_label(inputs)
});